export enum CalloutDisplayEnum {
  Modal = 'Modal',
  Footer = 'Footer',
  Notification = 'Notification',
}
